import { Button, Icon, Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

import { useCustomersAdded } from '../../../../hooks/customersAdded';
import { flatListProps } from '../../../../utils';
import { ItemSeparator } from '../../../ItemSeparator';
import { ClearSelectionButton } from '../../../SectionWrapper/button';
import { AddedCustomerItem } from '../AddedCustomerItem';
import { CustomersResumeCart } from '../CustomersResumeCart';
import { Empty } from '../Empty';

export const AddedCustomers: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { customerCartIsEmpty, customerCartItems, resetCustomerCart, handleAddCustomers } =
    useCustomersAdded();

  if (customerCartIsEmpty) {
    return <Empty />;
  }

  return (
    <VStack mt={Spacing['stack.xxxs']} space={Spacing['stack.xxxs']} flex={1}>
      <CustomersResumeCart />
      <HStack alignItems="center" justifyContent="space-between">
        {!isMobile ? (
          <Text variant="bold" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Itens adicionados
          </Text>
        ) : (
          <Button
            variant="textLink"
            onPress={handleAddCustomers}
            rightIcon={
              <Icon name="Addition" size="xxxs" color={Color['brand.tertiary.principal']} />
            }
            _text={{ fontFamily: Typography['fontfamily.base.semibold'] }}>
            ADICIONAR
          </Button>
        )}
        <ClearSelectionButton isDisabled={customerCartIsEmpty} onPress={resetCustomerCart} />
      </HStack>

      <Shadow level={3} flex={1}>
        <FlatList
          {...flatListProps}
          maxH="full"
          flex={1}
          data={customerCartItems}
          keyExtractor={(item) => item.accountNumber.toString()}
          ItemSeparatorComponent={ItemSeparator}
          renderItem={({ item }) => <AddedCustomerItem item={item} />}
        />
      </Shadow>
    </VStack>
  );
};
